module.exports = __webpack_public_path__ + "img/newsImg12-16.38628336.png";